export const UPDATE_LICENSE = 'update_license';
export const UPDATE_COMPANY_NAME = 'update_company_name';
export const UPDATE_NODES_CS = 'update_nodes_cs';
export const REFRESH_CONNECTION_STRINGS_SENT = 'refresh_connection_strings_sent';
